"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthGuard = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const jwt_1 = require("@nestjs/jwt");
const environment_1 = require("./environment");
const constants_1 = require("./constants");
// import { errorMessages } from "../../../../../libs/service-lib/src/lib/messages";
let AuthGuard = class AuthGuard {
    constructor(jwtService) {
        this.jwtService = jwtService;
    }
    canActivate(context) {
        const request = context.switchToHttp().getRequest();
        // By passing the login and register endpoints
        const serviceName = request.params.service;
        const path = request.path.replace(`/${constants_1.iirm}/${serviceName}`, '');
        if (constants_1.bypassAuthGuardApis.includes(path) || path.includes('/employee/password-reset-mail')) {
            return true;
        }
        const authHeader = request.headers.authorization;
        if (!authHeader) {
            throw new common_1.UnauthorizedException("Authorization header is missing");
        }
        const token = authHeader.split(" ")[1];
        try {
            const decoded = this.jwtService.verify(token, {
                secret: environment_1.ENV.JWT_SECRET,
            });
            request.user = decoded;
            return true;
        }
        catch (error) {
            throw new common_1.UnauthorizedException("Invalid or expired token");
        }
    }
};
exports.AuthGuard = AuthGuard;
exports.AuthGuard = AuthGuard = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof jwt_1.JwtService !== "undefined" && jwt_1.JwtService) === "function" ? _a : Object])
], AuthGuard);
